import { PpaStatus, ProductPromotionRequest, ProductPromotionStatusDetails } from "../dtos";

export class ProductPromotionRequestDialogData {
    affectedMaterial: string
    affectedMaterialText: string;
    business: string;
    isRequested: boolean;
    status: PpaStatus;
    allowedDiscoutnDollars: number
    allowedDiscountPercentage: number;
    authCode: string;
    statusDetails?: ProductPromotionStatusDetails;
    submittedRequest?: ProductPromotionRequest;
}